import { getRestautantData } from 'actions/restaurant';
import { getBanner } from 'actions/banner';
import { getPopups } from 'actions/popup';
import { getHotelMeta } from 'actions/hotel.js';

export default store => ({
	path: 'diningsandmeetings',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./container.js').default;
					cb(null, component);
				},
				'Restaurant',
			),
		onEnter: ({ params: { lang, hotel } }) => {
			store.dispatch(getRestautantData(lang, hotel));
			store.dispatch(getBanner(lang, hotel, 'restaurant'));
			store.dispatch(getPopups(lang, hotel));
			store.dispatch(getHotelMeta(lang, hotel, 'diningsandmeetings'));
		},
		onChange: (_, { params: { lang, hotel } }) => {
			store.dispatch(getRestautantData(lang, hotel));
		},
	},
});



// WEBPACK FOOTER //
// ./src/routes/Hotel/Restaurant/index.js